import { makeXeroLink } from '@local_modules/generic/xero/utilities/xero-links.js'
import { menuOptions } from './show-menu.js'
import { associateAccount } from './associate-account.js'
import { generateSelect } from '../../../../helpers/generic-js/menus/index.js'
import { generateOptions } from './intercompany/selector.js'
import { getChartOfAccountAssociation } from './intercompany/get-chart-of-account-association.js'

export function makeColumnDefs (viewParams) {
  const groupingProperty = menuOptions.optionGrouping.selectedOption()?.value || 'name'

  const columnDefs = [
    {
      headerName: groupingProperty === 'name' ? 'Account Name' : 'Account Code',
      valueGetter: function (cellParams) {
        return cellParams.data.grouping?.[groupingProperty]
      },
      pinned: 'left'
    }
  ]

  const entitiesColumns = makeEntitiesColumns(viewParams)
  columnDefs.push(...entitiesColumns)
  console.log('columnDefs', columnDefs)

  return columnDefs
}

/**
 *
 * @param {Object} viewParams
 * @returns
 */
function makeEntitiesColumns (viewParams) {
  const entitiesColumns = []

  const entities = viewParams.browserAppAccount.data.entities
  console.log('entities', entities)

  entities?.forEach(function (accountingOrganisation) {
    const columnDef = {
      headerName: accountingOrganisation.name,
      width: 180,
      context: {
        accountingOrganisation
      },
      onCellClicked: function (cellParams) {
        console.log('cellClicked', cellParams, cellParams.value)
        console.log('cellClicked organisation', cellParams.colDef.context.accountingOrganisation)

        const selectedValue = getSelectedValue(cellParams)
        console.log('selectedValue', selectedValue)
        // analyseChartOfAccountAssociation(cellParams)
        // const cellValue = getCellValue(cellParams)
        // console.log('cellValue', cellValue)
      },

      valueGetter: function (cellParams) {
        if (cellParams.node.rowPinned) {
          return makeXeroLink('ChartAccounts', {
            shortCode: accountingOrganisation.xero_shortcode
          })
        }

        return getCellValue(cellParams)
      },
      cellRenderer: function (cellParams) {
        if (cellParams.node.rowPinned) {
          const linkToXero = cellParams.value
          // Could even do to ?q=AccountName for specific account
          return `<a href='${linkToXero}' target='_blank'>Open in Xero</a>`
        }
        return cellRenderer(cellParams)
      }
    }

    entitiesColumns.push(columnDef)
  })

  // console.log(entitiesColumns)
  return entitiesColumns
}

function getColumnOrgValues (cellParams) {
  const columnAccountingOrganisationId = cellParams.colDef.context.accountingOrganisation.id
  const orgValues = cellParams.data.valuesByAccountingOrganisationId.get(columnAccountingOrganisationId)

  return orgValues
}

function getCellValue (cellParams) {
  const orgValues = getColumnOrgValues(cellParams)
  if (!orgValues) return null
  if (orgValues.length === 0) return null
  if (orgValues.length > 1) return 'multiple accounts'

  const orgValue = orgValues[0]
  const outputShow = cellParams.context?.menuOptions?.outputShow?.selectedOption()?.value || 'type'

  switch (outputShow) {
    case 'associatedEntity':
      return orgValue.associatedEntity?.name || 'none'
    case 'type':
      return orgValue.xero_type
    case 'code':
      return orgValue.code
    case 'name':
      return orgValue.name
  }
}

function cellRenderer (cellParams) {
  const orgValues = getColumnOrgValues(cellParams)
  if (!orgValues) return null
  if (orgValues.length === 0) return null
  if (orgValues.length > 1) return 'multiple accounts'

  const orgValue = orgValues[0]
  const outputShow = cellParams.context?.menuOptions?.outputShow?.selectedOption()?.value || 'type'

  switch (outputShow) {
    case 'associatedEntity':
      return showIntercompanySelector(cellParams)
    case 'type':
      return `${orgValue.statement === 'bs' ? 'Balance Sheet' : 'P&L'} ${orgValue.xero_type}`
    case 'code':
      return `<span class="tag is-info is-light">${orgValue.code ? orgValue.code : '! No Code'}</span> `
    case 'name':
      return orgValue.name
  }
}

function showIntercompanySelector (cellParams) {
  const selectOptions = generateOptions(cellParams)

  const selectedValue = getSelectedValue(cellParams)

  const selectInstance = generateSelect({
    onChange: async function (selectedValue, selectInstance) {
      // For some reason, selectInstance.selectedValue, cellParams.data.selectInstance.selectedValue are not the same: as it the instance object is a shallow copy of the original??
      console.log('selector', selectedValue, selectInstance.selectedValue, cellParams.data.selectInstance.selectedValue)

      await associateAccount(cellParams, selectedValue)
    },
    selectOptions,
    selectedValue
  })
  cellParams.data.selectInstance = selectInstance

  selectInstance.DOMelement.classList.add('zen-vertical-align-baseline')
  // selectInstance.DOMelement.classList.add('light-border')

  if (cellParams.data.isLoading) {
    selectInstance.DOMelement.classList.add('is-loading')
    selectInstance.selectElement.setAttribute('disabled', 'disabled')
  }

  if (selectedValue === 'none') {
    selectInstance.selectElement.classList.add('is-info')
  } else {
    selectInstance.selectElement.classList.remove('is-success')
  }

  return selectInstance.DOMelement
}

function getSelectedValue (cellParams) {
  // console.log('getSelectedValue', cellParams)
  const { associatedChartOfAccount, entity } = getChartOfAccountAssociation(cellParams)
  // console.log('associatedChartOfAccount', associatedChartOfAccount)
  if (!associatedChartOfAccount) return 'none'

  return entity?.id
}
